import { searchHero as schema } from 'web/schemas/contentful/_schema.mjs';
import { fakeProps } from 'web/schemas/contentfulTestData';

const TestData = {
  header: 'Live your luxury.',
  propertyImages: [
    {
      image: '/assets/search-hero-bg.png',
      header: 'Santa Barbara, California',
      subHeader: '$1,450,000',
      ctaUrl: '/',
    },
    {
      image: '/assets/yachtplaceholder.png',
      header: 'Chicago, Illinois',
      subHeader: '$1,500,000',
      ctaUrl: '/',
    },
    {
      image: '/assets/textimageplaceholder.png',
      header: 'New York, New York',
      subHeader: '$1,200,000',
      ctaUrl: '/',
    },
    {
      image: '/assets/blogplaceholder.png',
      header: 'Los Angeles, California',
      subHeader: '$1,000,000',
      ctaUrl: '/',
    },
  ],
};

export default fakeProps(schema, TestData);
